// extracted by mini-css-extract-plugin
module.exports = {"homepageBlock":"index--homepageBlock--3hN_h","last":"index--last--3mYGM"};